import { Controller } from "@hotwired/stimulus"

// Drag-to-reorder for the Meeting Templates admin table. Native HTML5
// DnD on <tr data-template-id="…"> rows; on drop, POSTs the new order
// as `template_ids[]` to the reorder endpoint. Position persists
// server-side; the UI updates optimistically. Mirrors
// meeting_topic_admin_controller.js.
export default class extends Controller {
  static targets = ["list", "row"]
  static values = { reorderUrl: String, csrf: String }

  connect() {
    this._draggingRow = null
  }

  rowTargetConnected(row) {
    if (row.dataset.dragWired === "true") return
    row.dataset.dragWired = "true"
    row.addEventListener("dragstart", (e) => this._onDragStart(e, row))
    row.addEventListener("dragover", (e) => this._onDragOver(e, row))
    row.addEventListener("drop", (e) => this._onDrop(e, row))
    row.addEventListener("dragend", () => this._onDragEnd(row))
  }

  _onDragStart(event, row) {
    this._draggingRow = row
    row.classList.add("opacity-40", "bg-blue-50")
    if (event.dataTransfer) {
      event.dataTransfer.effectAllowed = "move"
      event.dataTransfer.setData("text/plain", row.dataset.templateId)
    }
  }

  _onDragOver(event, row) {
    if (!this._draggingRow || row === this._draggingRow) return
    event.preventDefault()
    if (event.dataTransfer) event.dataTransfer.dropEffect = "move"
    row.classList.add("border-t-2", "border-brand")
  }

  _onDrop(event, row) {
    event.preventDefault()
    row.classList.remove("border-t-2", "border-brand")
    if (!this._draggingRow || row === this._draggingRow) return

    const dragged = this._draggingRow
    const { top, height } = row.getBoundingClientRect()
    const dropAbove = event.clientY < top + height / 2
    this.listTarget.insertBefore(dragged, dropAbove ? row : row.nextSibling)
    this._persistOrder()
  }

  _onDragEnd(row) {
    row.classList.remove("opacity-40", "bg-blue-50")
    this.rowTargets.forEach((r) => r.classList.remove("border-t-2", "border-brand"))
    this._draggingRow = null
  }

  _persistOrder() {
    const ids = this.rowTargets.map((r) => r.dataset.templateId).filter(Boolean)
    if (!ids.length || !this.hasReorderUrlValue) return

    const formData = new FormData()
    ids.forEach((id) => formData.append("template_ids[]", id))

    fetch(this.reorderUrlValue, {
      method: "POST",
      headers: {
        "X-CSRF-Token": this.csrfValue || this._csrfFallback(),
        Accept: "application/json"
      },
      credentials: "same-origin",
      body: formData
    }).catch((err) => console.warn("[meeting-template-admin] reorder failed:", err))
  }

  _csrfFallback() {
    const meta = document.querySelector('meta[name="csrf-token"]')
    return meta ? meta.content : ""
  }
}
